import { Reveal } from "@/components/Reveal";

/* Real brand logos + client-category text marks.
   Logos live in /app/frontend/public/logos/*.png (transparent). */
const LOGOS = [
  { src: "/logos/amazon.png", alt: "Amazon", w: "w-[170px] md:w-[210px]" },
  { src: "/logos/ert.png", alt: "ΕΡΤ · Hellenic Broadcasting", w: "w-[80px] md:w-[100px]" },
  { src: "/logos/avocado.png", alt: "Avocado Learning Experiences", w: "w-[190px] md:w-[240px]" },
];

const CLIENT_MARKS = [
  "Executives",
  "Founders",
  "Business Leaders",
  "TV Presenters",
  "Journalists",
  "Consultants",
];

export const TrustMarquee = () => {
  return (
    <section
      className="relative z-10 py-12 md:py-16 border-y border-ink/10 bg-paper-deep/40"
      data-testid="trust-marquee"
    >
      <Reveal className="max-w-[1400px] mx-auto px-5 md:px-10 mb-8 md:mb-10">
        <p className="font-body text-xs uppercase tracking-[0.24em] text-ink-soft text-center">
          Trusted by clients &amp; collaborators including
        </p>
      </Reveal>

      {/* Real logos */}
      <div
        className="max-w-[1400px] mx-auto px-5 md:px-10 flex flex-wrap items-center justify-center gap-12 md:gap-20 mb-10 md:mb-14"
        data-testid="trust-logos"
      >
        {LOGOS.map((l) => (
          <img
            key={l.alt}
            src={l.src}
            alt={l.alt}
            draggable={false}
            className={`${l.w} h-auto opacity-90 hover:opacity-100 transition-opacity duration-500 select-none`}
          />
        ))}
      </div>

      {/* Client-category marquee (professional roles) */}
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex w-max animate-marquee items-center gap-14 md:gap-20 whitespace-nowrap">
          {[...CLIENT_MARKS, ...CLIENT_MARKS].map((c, i) => (
            <span
              key={i}
              className="font-serif italic text-xl md:text-3xl text-ink/45 hover:text-ink transition-colors duration-500"
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
